import React from "react";
import { ActivityIndicator, View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import { SafeAreaView } from "react-native-safe-area-context";
import { AppText } from "@/components/AppText";

export function LoadingScreen() {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#4F46E5" />
        <AppText style={styles.loadingText}>Loading offers...</AppText>
      </View>
    </SafeAreaView>
  );
}

export function EmptyState() {
  return (
    <View style={styles.emptyContainer}>
      <AppText style={styles.emptyText}>No offers available</AppText>
      <AppText style={styles.emptySubtext}>
        Check back later for new opportunities
      </AppText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: 16,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: "#6B7280",
  },
  emptyContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 24,
    paddingTop: 60,
  },
  emptyText: {
    fontSize: 18,
    fontWeight: "600",
    color: "#374151",
    textAlign: "center",
    marginBottom: 8,
  },
  emptySubtext: {
    fontSize: 14,
    color: "#6B7280",
    textAlign: "center",
  },
});
